import classNames from 'classnames';
import React, { useState, useEffect, useRef } from 'react';
import NavLink from 'next/link';
import useOutsideClick from '@/hook/useOutsideClick';
import useLangSwitcher from '@/hook/useLangSwitcher';
import styles from './lang-switcher.module.scss';

const langArr = ['en', 'pl'];

const LangSwitcher = (props: { lang: string; route?: string; size?: 's' | 'm'; languages?: string[]; color?: string;}) => {
  const [isOpenSwitcher, setIsOpenSwitcher] = useState(false);
  const [activeSwitcher, setActiveSwitcher] = useState('');
  const containerRef = useRef(null);
  const { lang, getLangLink } = useLangSwitcher({ lang: props.lang, route: props.route });

  const openLangTooltip = () => {
    setIsOpenSwitcher(!isOpenSwitcher);
  };

  useOutsideClick(containerRef.current, null, () => {
    setIsOpenSwitcher(false);
  });

  useEffect(() => {
    setActiveSwitcher(lang);
  }, [props.route]);

  return (
    <div
      className={classNames(styles['lang-switcher'], {
        [styles.small]: props.size === 's',
      })}
      ref={containerRef}
    >
      <button
        type="button"
        onClick={openLangTooltip}
        className={classNames(styles['selected-switch'], {
          [styles['is-active']]: isOpenSwitcher,
        })}
      >
        {activeSwitcher}
      </button>

      {isOpenSwitcher ? (
        <ul className={styles['list-switch']} style={{ background: props.color }}>
          {(props.languages || langArr).map((langItem) => (
            <li
              key={langItem}
              className={classNames(styles['item-switch'], {
                [styles['is-active']]: activeSwitcher === langItem,
              })}
            >
              <NavLink
                href={getLangLink(langItem)}
                className={styles['link-item-switch']}
              >
                {langItem}
              </NavLink>
            </li>
          ))}
        </ul>
      ) : null }
    </div>
  );
};

LangSwitcher.defaultProps = {
  size: 'm',
};

export default LangSwitcher;
